// Libs
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Utils
import { filterOption } from 'utils/libs';
import { formatArticlesData } from 'utils/libs/dateFormats';
// Context
import { ModalBuilderContext } from 'core/context';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Selectors
import { selectProfile } from 'screens/Login/selectors';
// Hooks
import useOrderApi from 'core/hooks/useCoreApi';
import { createNewPackageOptionsLoader } from './NewPackge.loader';
// Components
import {
	Wrapper,
	Modal,
	Title,
	LogoIcon,
	Button,
	Select,
	Divider,
	AddIcon,
	TextField,
	CloseIcon,
} from 'components';

const { Input } = TextField;

const SelectOption = ({
	placeholder,
	options,
	inputValue,
	state,
	setState,
	selectOptionValue,
	setSliceState,
	isMustCreateAreaZone,
}) => {
	const optionSelect = options.map((item, idx) => {
		const preValue = item.item ? `${item.item} - ` : '';

		return (
			<Select.Option key={idx} value={item.id || item.item_id}>
				<em>{`${preValue} ${item.name}`}</em>
			</Select.Option>
		);
	});

	const typeOperationSelector = placeholder.toLowerCase().replace('*', '');
	const isZoneType = typeOperationSelector == 'zona';

	const handleInputChange = ({ id, value }) => {
		setState({ [id]: value });
	};

	const handleIsOpenInput = ({ isOpen: mustCreate }) => {
		setState({
			zona: isZoneType && mustCreate ? '' : undefined,
			area: mustCreate ? '' : undefined,

			selectedZoneId:
				isZoneType && mustCreate ? undefined : state.selectedZoneId,
			selectedAreaId: mustCreate ? undefined : state.selectedAreaId,

			mustCreateZone: isZoneType && mustCreate,
			mustCreateArea: mustCreate,
		});
	};

	const createOption = menu => (
		<div>
			{menu}
			<Divider style={{ margin: '4px 0' }} />
			<div
				style={{ padding: '4px 8px', cursor: 'pointer' }}
				onMouseDown={e => e.preventDefault()}
				onClick={() => handleIsOpenInput({ isOpen: true })}
			>
				<AddIcon /> Añadir {placeholder.replace('*', '')}
			</div>
		</div>
	);

	const isValidField =
		typeOperationSelector === 'zona' || typeOperationSelector === 'area';

	const isOpen =
		state?.mustCreateZone ||
		(typeOperationSelector === 'area' && state?.mustCreateArea);

	const isOpenInput = isValidField && isOpen;

	return isOpenInput ? (
		<Input
			autoFocus
			margin='0 0 5px 0'
			id={typeOperationSelector}
			placeholder={placeholder}
			maxLength={15}
			value={inputValue}
			onChange={({ target }) => {
				handleInputChange({ id: target.id, value: target.value });
			}}
			suffix={
				<CloseIcon onClick={() => handleIsOpenInput({ isOpen: false })} />
			}
		/>
	) : (
		<Select
			margin='0 0 5px 0'
			autofocus
			showSearch
			width='100%'
			placeholder={placeholder}
			value={selectOptionValue}
			filterOption={filterOption}
			onChange={value => setState({ [setSliceState]: value })}
			dropdownRender={
				isMustCreateAreaZone && optionSelect.length && createOption
			}
		>
			{optionSelect}
		</Select>
	);
};

const SendButton = ({
	state,
	stateTable,
	setTemporalData,
	getData,
	transactionId,
	wtdiId,
	cleanModal,
}) => {
	const [isFetching, setIsFetching] = useState(false);
	const dispatch = useDispatch();

	const { createPakage, upsertArticle } = useOrderApi();

	const sendMessage = ({ message, type = 'warn' }) => {
		dispatch(
			sendToast({
				message,
				type,
				duration: 2,
			}),
		);
	};

	const onCreateNewPackage = () => {
		const wtdiData =
			wtdiId &&
			stateTable.find(
				item =>
					item.id == wtdiId || item.wtdi_id == wtdiId || item.wtdiId == wtdiId,
			);
		const selectedZone = state.zones.find(
			zone => zone.id == state.selectedZoneId,
		);
		const selectedArea = state.areas.find(
			area => area.id == state.selectedAreaId,
		);
		const selectedArticle = state.articles.find(
			article =>
				article.id == state.selectedItemId ||
				article.item_id == state.selectedItemId,
		);
		const selectedState = state.stateArticles.find(
			stateArticle => stateArticle.id == state.selectedStateId,
		);

		if (!wtdiId && !state.selectedItemId) {
			sendMessage({ message: ' Debe completar los campos requeridos [*]' });
			return;
		}

		setIsFetching(current => !current);

		const pkg = {
			item_id: wtdiData?.itemId || state.selectedItemId,
			amount: undefined,
			warehouse_area_id: state.selectedAreaId,
			warehouse_zone_id: state.selectedZoneId,
			zone: state?.zona?.trim() || undefined,
			area: state?.area?.trim() || undefined,
			mustCreateZone: state.mustCreateZone,
			mustCreateArea: state.mustCreateArea,
		};

		createPakage(pkg)
			.then(createdPackage => {
				if (!wtdiId) {
					setTemporalData({
						wtdId: transactionId,
						stateItem: state.selectedStateId,
						stateName: selectedState?.name,
						itemId: state.selectedItemId,
						itemCode:
							selectedArticle?.item ??
							selectedArticle?.item_code ??
							selectedArticle?.itemCode,
						itemName:
							selectedArticle?.name ??
							selectedArticle?.item_name ??
							selectedArticle?.itemName,
						packageId: createdPackage.id,
						zoneName: state.zona?.trim() || selectedZone?.name,
						areaName: state.area?.trim() || selectedArea?.name,
					});
					sendMessage({ message: 'Paquete creado!', type: 'success' });
					setIsFetching(current => !current);
				} else {
					upsertArticle({
						ids: { wtdiId },
						fields: { packageId: createdPackage.id },
					}).then(() => {
						getData();
						sendMessage({ message: 'Item Agregado!', type: 'success' });
						setIsFetching(current => !current);
					});
				}

				cleanModal();
			})
			.catch(({ message }) => {
				sendMessage({ message, type: 'error' });
				setIsFetching(current => !current);
				cleanModal();
			});
	};

	return (
		<Wrapper
			padding='0'
			margin='10px 0 0 0'
			width={1200}
			flexDirection='column'
			alignItems='center'
		>
			{isFetching ? (
				<LogoIcon spin />
			) : (
				<Button mode='primary' onClick={onCreateNewPackage}>
					Crear
				</Button>
			)}
		</Wrapper>
	);
};

const CreateNewPackge = () => {
	const [state, _setState] = useState({
		selectedItemId: undefined,
		selectedStateId: undefined,
		selectedZoneId: undefined,
		selectedAreaId: undefined,

		zona: undefined,
		area: undefined,

		mustCreateZone: false,
		mustCreateArea: false,

		articles: [],
		stateArticles: [],
		zones: [],
		areas: [],
	});

	const { getArticles, getItemStates, getZonesAreas } = useOrderApi();

	const setState = newState =>
		_setState(currentState => ({ ...currentState, ...newState }));

	const { payload: modalPayload, cleanModal } = useContext(ModalBuilderContext);

	const profile = useSelector(selectProfile);
	const dispatch = useDispatch();

	const {
		stateTable,
		setTemporalData = () => {},
		getData,
		transactionId,
		wtdiId,
	} = modalPayload;

	const formatRows = response =>
		response.map(row =>
			formatArticlesData(
				row,
				profile.organization.tz,
				profile.user.settings.date_format,
			),
		);

	const sendLoadError = () =>
		dispatch(
			sendToast({
				message: 'No fue posible cargar los datos del paquete',
				type: 'error',
				duration: 2,
			}),
		);

	useEffect(() => {
		const loader = createNewPackageOptionsLoader({
			getArticles,
			getItemStates,
			getZonesAreas,
			formatRows,
		});

		loader.load({ onSuccess: setState, onError: sendLoadError });

		return loader.cancel;
	}, []);

	return (
		<Modal
			title={null}
			closable={false}
			centered={false}
			visible={true}
			onCancel={cleanModal}
			footer={null}
		>
			<Wrapper
				highBackground
				width='100%'
				margin='0'
				flexDirection='column'
				alignItems='center'
				justifyContent='flex-start'
			>
				<Title>Nuevo Paquete</Title>
				<Wrapper
					padding='0'
					width='50%'
					flexDirection='column'
					alignItems='stretch'
				>
					{!wtdiId && (
						<>
							<SelectOption
								placeholder='Artículo*'
								options={state.articles}
								setState={setState}
								selectOptionValue={state.selectedItemId}
								setSliceState={'selectedItemId'}
							/>
							<SelectOption
								placeholder='Estado*'
								options={state.stateArticles}
								setState={setState}
								selectOptionValue={state.selectedStateId}
								setSliceState={'selectedStateId'}
							/>
						</>
					)}
					<SelectOption
						placeholder='Zona*'
						options={state.zones}
						state={state}
						setState={setState}
						selectOptionValue={state.selectedZoneId}
						setSliceState={'selectedZoneId'}
						isMustCreateAreaZone
					/>

					<SelectOption
						placeholder='Area*'
						options={state.areas.filter(
							areas => areas.warehouse_zone_id == state.selectedZoneId,
						)}
						state={state}
						setState={setState}
						selectOptionValue={state.selectedAreaId}
						setSliceState={'selectedAreaId'}
						isMustCreateAreaZone
					/>

					<SendButton
						state={state}
						stateTable={stateTable}
						setTemporalData={setTemporalData}
						getData={getData}
						transactionId={transactionId}
						wtdiId={wtdiId}
						cleanModal={cleanModal}
					/>
				</Wrapper>
			</Wrapper>
		</Modal>
	);
};

export default CreateNewPackge;
